<template>
  <div>
    <div :style="style">
      <img v-for="(item, index) in landingPages" :key="index" :class="setImgClassName(item)" :ref="setImgRef(item)"
        @click="handleClick(item)" :style="item.url && buttonStyle" :src="item.pic" alt="" />
    </div>
    <adv-cookie-consent v-if="isShowCookie" @showCookieState="handleShowCookieState"
      @cookieConsentHeight="handleCookieHeight" :initOmega="omega" width="450">
    </adv-cookie-consent>
  </div>
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  nextTick,
} from "@vue/composition-api";
import { IMGS_ACCTION_TYPE } from "./config";
import Omega from "@/utils/register/omega";
import { querySet } from "@/utils/url";
import { TResourceItem } from "./type";

interface LandingPage {
  pic: string;
  action: number;
  url?: string;
}

type ImgRefType = HTMLElement[] | null;

export default defineComponent({
  name: "market-home",
  props: {
    data: {
      type: Object as () => TResourceItem,
      required: true,
      default: null,
    },
  },
  setup(props) {
    performance.mark('home-p4-start')
    const imgHeight = ref(0);
    const cookieHeight = ref(0);
    const isShowCookie = ref(false);
    const isMedia = ref(false);
    const imgRef = ref<ImgRefType>(null);
    const omega = { Omega: window.Omega, params: {} };
    // 页面展现埋点
    const landingPages = ref([] as Array<LandingPage>);

    const style = computed(() => {
      return {
        paddingBottom: `${cookieHeight.value + imgHeight.value}px`,
      };
    });

    const buttonStyle = computed(() => {
      return {
        bottom: `${cookieHeight.value}px`,
      };
    });
    // encode参数值
    function encodeParams(query: { [key: string]: string }) {
      const arr = Object.keys(query);
      if (arr && arr.length > 0) {
        return arr
          .map((item) => `${item}=${encodeURIComponent(query[item])}`)
          .join("&");
      }
      return "";
    }
    // 拼接参数
    function spliceParams(url: string): string {
      const query = querySet;
      const marketParams = encodeParams(query);
      // 如果 URL 中包含查询参数（即有 `?`），则用 `&` 拼接
      return `${url}${url.includes("?") ? "&" : "?"}${marketParams}`;
    }
    function handleClick(config: LandingPage) {
      const { action, url } = config;
      if (action === IMGS_ACCTION_TYPE["JUMP"] && url) {
        // 申请按钮点击埋点
        Omega?.trackEvent("fin_credit_abroad_apply_bureau_outcast_ck");
        window.open(spliceParams(url), "_blank");
      }
    }

    function handleShowCookieState(event: CustomEvent) {
      if (!event.detail) {
        cookieHeight.value = 0;
      }
    }

    function handleCookieHeight(event: CustomEvent) {
      cookieHeight.value = event.detail;
    }

    function setImgRef(item: LandingPage) {
      const { action } = item;
      return action === IMGS_ACCTION_TYPE["JUMP"] ? "imgRef" : "";
    }

    function setImgClassName(item: LandingPage) {
      const { action } = item;
      return action === IMGS_ACCTION_TYPE["JUMP"]
        ? ["outbound-img", "jump-img"]
        : "outbound-img";
    }

    function init() {
      const env = window?.adv?.getEnv();
      const { landing_backgrounds, switcher } = props.data || {};
      landingPages.value = landing_backgrounds || [];
      isShowCookie.value = switcher?.cookie;
      isMedia.value = switcher?.media;
      if (isMedia.value && env) {
        window?.adv?.mediaEventUp(5001, { // 5001: 页面展现埋点
          env,
          pixelUp: true,
          httpUp: true,
          data: {},
        });
      }
      performance.mark('home-p4-end')
    }

    init();

    onMounted(() => {
      // 页面埋点
      Omega?.trackEvent("fin_credit_abroad_apply_bureau_outcast_sw");
      nextTick(() => {
        if (imgRef.value) {
          imgRef.value[0].onload = (e: any) => {
            imgHeight.value = e.target?.clientHeight;
          };
        }
      });
    });

    return {
      omega,
      style,
      isMedia,
      isShowCookie,
      landingPages,
      handleClick,
      handleShowCookieState,
      handleCookieHeight,
      setImgRef,
      setImgClassName,
      buttonStyle,
      imgRef,
    };
  },
});
</script>
<style scoped>
.outbound-img {
  width: 100%;
  height: auto;
}

.jump-img {
  width: 750px;
  height: auto;
  position: fixed;
}

img {
  display: block;
}
</style>